module.exports = require('../../full/object/has-own');
